import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKidsPlayworldinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M32 5l17 16H15zm-6 25h13M24 45h16M24 30h16"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M20 37L4 51" }),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 32,
				cy: 14,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M20 45L4 59m40-24l15 14v8L44 43.5M8 47v8.5M12 44v8m4-12v8.5" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 21v34.907C24 57.063 23.105 58 22 58s-2-.937-2-2.093V21.286M40 21v34.907c0 1.156.895 2.093 2 2.093s2-.937 2-2.093V21.286",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgKidsPlayworldinline;
